import React from 'react';
import { Link } from 'react-router-dom';
import DropdownLanguage from './dropdown/language.jsx';
import DropdownProfile from './dropdown/profile.jsx';
import DropdownMegaMenu from './dropdown/mega.jsx';
import ClientContextSelector from '../selector/client-context-selector.jsx';

import { AppSettings } from '../../config/app-settings.js';
import Breadcrumb from '../general/breadcrumb.jsx';

function Header() {
	return (
		<AppSettings.Consumer>
			{({toggleAppSidebarMobile, toggleAppSidebarEnd, toggleAppSidebarEndMobile, toggleAppTopMenuMobile, appHeaderLanguageBar, appHeaderMegaMenu, appHeaderInverse, appSidebarTwo, appTopMenu, appSidebarNone}) => (
				<div id="header" className="app-header" data-bs-theme={appHeaderInverse ? 'dark' : ''}>
					<div className="navbar-header">
						{appSidebarTwo && (
							<button type="button" className="navbar-mobile-toggler" onClick={toggleAppSidebarEndMobile}>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
							</button>
						)}
						<Link to="/dashboard-panels/dashboard" className="navbar-brand">
							<img src="/favicon-96x96.png" alt="Traffica" className="navbar-icon mx-2" />
							<b>Traffica</b> 
						</Link>
						
						{appHeaderMegaMenu && (
							<button type="button" className="navbar-mobile-toggler" data-bs-toggle="collapse" data-bs-target="#top-navbar">
								<span className="fa-stack fa-lg text-inverse">
									<i className="far fa-square fa-stack-2x"></i>
									<i className="fa fa-cog fa-stack-1x"></i>
								</span>
							</button>
						)}
						{appTopMenu && !appSidebarNone && (
						<button type="button" className="navbar-mobile-toggler" onClick={toggleAppTopMenuMobile}>
							<span className="fa-stack fa-lg text-inverse">
								<i className="far fa-square fa-stack-2x"></i>
								<i className="fa fa-cog fa-stack-1x"></i>
							</span>
						</button>
						)}
						{appSidebarNone && appTopMenu && (
							<button type="button" className="navbar-mobile-toggler" onClick={toggleAppTopMenuMobile}>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
							</button>
						)}
						{!appSidebarNone && (
							<button type="button" className="navbar-mobile-toggler" onClick={toggleAppSidebarMobile}>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
							</button>
						)}
					</div>
					
					{appHeaderMegaMenu && (
						<DropdownMegaMenu />
					)}
					
					<div className="navbar-nav">
						{appHeaderLanguageBar && (
							<DropdownLanguage />
						)}

						<div className="flex-grow-1 d-flex justify-content-center">
							<Breadcrumb />
						</div>
						
						<ClientContextSelector />
						
						<DropdownProfile />
						
						{appSidebarTwo && (
							<div className="navbar-divider d-none d-md-block"></div>
						)}
						
						{appSidebarTwo && (
							<div className="navbar-item d-none d-md-block">
								<Link to="/" onClick={toggleAppSidebarEnd} className="navbar-link icon">
									<i className="fa fa-th"></i>
								</Link>
							</div>
						)}
					</div>
				</div>
			)}
		</AppSettings.Consumer>
	)
}

export default Header;
